import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import I18n from '../../lib/I18n';
import { cdnHost } from '../../../config';
import CopyText from '../../molecules/Icon/CopyText';
import './index.less';
import { getIdentity } from '../../lib/Identity';
import { showAlert } from '../../lib/Utils';

export default ({ buttonStyle, couponCode, onClose }) => {
  const couponCodeRef = useRef(null);
  const [name, setName] = useState('');

  useEffect(() => {
    getIdentity().then((visitor) => setName(visitor.name));
  }, []);

  const copyCouponCode = (event) => {
    event.preventDefault();
    const range = document.createRange();
    range.selectNode(couponCodeRef.current);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    showAlert(I18n.t('COUPON_CODE_APPIED'));
  };

  return (
    <Fragment>
      <div className="offer-title">
        {I18n.t('THANKS')}
        {' ' + name + '!'}
      </div>
      <div className="coupon-subtitle" style={{ color: buttonStyle.backgroundColor }}>
        {I18n.t('HERE_IS_YOUR_COUPON_CODE')}
      </div>
      <div className="coupon-options">
        <div
          className="offer-coupon"
          ref={couponCodeRef}
          style={{
            ...buttonStyle,
            color: buttonStyle.textColor,
            border: 'none',
            backgroundImage: 'unset'
          }}
        >
          {couponCode}
        </div>
        <div
          className="coupon-code"
          onClick={copyCouponCode}
          style={{ color: buttonStyle.backgroundColor }}
        >
          <CopyText fill={buttonStyle.backgroundColor} className={'copy-icon'} />
          {I18n.t('COPY_CODE')}
        </div>
      </div>
      <div className="coupon-info">
        {I18n.t('COUPON_WILL_BE_AUTOMATICALLY_APPLIED_ON_YOUR_CART')}
      </div>
      <button
        className="get-off-button common-field"
        onClick={onClose}
        style={{ ...buttonStyle, color: buttonStyle.textColor, border: 'none' }}
      >
        {I18n.t('CONTINUE_SHOPPING')}
        <img alt className="party-popper" src={`${cdnHost}assets/party-popper.svg`} />
      </button>
    </Fragment>
  );
};
